import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllToppings,
  getSingleToppingById,
  createTopping,
  updateTopping,
  deleteTopping,
} from "@/api/new-api/staff-management/menu-manage/essential-menu/topping";

// Thunks

export const fetchAllToppings = createAsyncThunk(
  "toppings/fetchAll",
  async ({ restaurant_id, menu_id }, { rejectWithValue }) => {
    const res = await getAllToppings(restaurant_id, menu_id);
    if (res.status === "success") return res.data.toppings;
    return rejectWithValue(res.message);
  }
);

export const fetchSingleTopping = createAsyncThunk(
  "toppings/fetchOne",
  async (id, { rejectWithValue }) => {
    const res = await getSingleToppingById(id);
    if (res.status === "success") return res.data.topping;
    return rejectWithValue(res.message);
  }
);

export const createNewTopping = createAsyncThunk(
  "toppings/create",
  async (data, { rejectWithValue }) => {
    const res = await createTopping(data);
    if (res.status === "success") return res.data.topping;
    return rejectWithValue(res.message);
  }
);

export const updateExistingTopping = createAsyncThunk(
  "toppings/update",
  async ({ id, data }, { rejectWithValue }) => {
    const res = await updateTopping(id, data);
    if (res.status === "success") return res.data.topping;
    return rejectWithValue(res.message);
  }
);

export const deleteToppingById = createAsyncThunk(
  "toppings/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteTopping(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State

const initialState = {
  toppings: [],
  singleTopping: null,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
};

// Slice

const toppingSlice = createSlice({
  name: "toppings",
  initialState,
  reducers: {
    clearToppingMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchAllToppings.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllToppings.fulfilled, (state, action) => {
        state.getLoading = false;
        state.toppings = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchAllToppings.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Fetch Single
      .addCase(fetchSingleTopping.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchSingleTopping.fulfilled, (state, action) => {
        state.getLoading = false;
        state.singleTopping = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchSingleTopping.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Create
      .addCase(createNewTopping.pending, (state) => {
        state.createLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(createNewTopping.fulfilled, (state, action) => {
        state.createLoading = false;
        state.toppings.push(action.payload);
        state.success = "Tropping created successfully!";
        state.requestStatus = true;
      })
      .addCase(createNewTopping.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Update
      .addCase(updateExistingTopping.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(updateExistingTopping.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.toppings = state.toppings.map((topping) =>
          topping.id === action.payload.id ? action.payload : topping
        );
        state.success = "Tropping updated successfully!";
        state.requestStatus = true;
      })
      .addCase(updateExistingTopping.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Delete
      .addCase(deleteToppingById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteToppingById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.toppings = state.toppings.map((item) =>
          item.id === action.payload ? { ...item, status: "archive" } : item
        );
        state.success = "Tropping deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteToppingById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearToppingMessages } = toppingSlice.actions;
export default toppingSlice.reducer;
